class Period {
    period;
    periodMultiplier;
    constructor(response) {
        this.period = response.period;
        this.periodMultiplier = response.periodMultiplier;
    }
    print() {
        return this.periodMultiplier.toString() + this.period;
    }
}
export default Period;
